
import {initWebComponent} from "@/helpers/web-component-helper";
import {initHideButton, showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {
    clearInfoCharacteristics,
    isInfoCharacteristicsLoaded
} from "@/helpers/layer/info/layer-info-characteristics-helper";

export class LayerInfoLayerMenuButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<layer-info-button data-icon="fa fa-layer-group" data-title="openLayerMenu"></layer-info-button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            const layerMenu = document.querySelector('layer-menu')
            const classList = layerMenu.classList

            if(classList.contains('d-none')) {
                classList.remove('d-none')
            } else {
                classList.add('d-none')
            }
        })
    }
}

